export default __webpack_public_path__ + "static/media/warning--triple-curve-right--g1.2d533c31.png";